import { z } from "zod";
import { CommonModels } from "@/data/common/common.models";

export namespace PublicProjectsModels {
/** 
 * GetProjectsResponseSchema 
 * @type { object }
 * @property { object[] } order List of order definitions 
 * @property { number } page 1-indexed page number to begin from 
 * @property { string } cursor ID of item to start after 
 * @property { string } nextCursor Cursor for next set of items 
 * @property { number } limit Items per response 
 * @property { number } totalItems Total available items 
 * @property { CommonModels.ProjectWithMediaDto[] } items  
 */
export const GetProjectsResponseSchema = z.object({ ...CommonModels.PaginationDtoSchema.shape, ...z.object({ items: z.array(CommonModels.ProjectWithMediaDtoSchema).nullable() }).partial().shape });
export type GetProjectsResponse = z.infer<typeof GetProjectsResponseSchema>;


}
